import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicDivisionDto extends EpimsBaseEntityDto {
  DivisionName: string;
  BranchCode: string;
  SubscriptionUserId: string;
  Version: number;
}
